module.exports = __webpack_public_path__ + "static/media/home_icon.51ec691d.svg";